export const IS08601_SECOND_BEFORE_MIDNIGHT_TIME = 'T23:59:59';
